export function getCamelCaseFromHyphenated(elId: string) {
    const dataIdArray = elId.split('-');
    if (dataIdArray && dataIdArray.length > 1) {
        for (let i = 1; i < dataIdArray.length; i++) {
            dataIdArray[i] = dataIdArray[i].capitalizeFirstLetter();
        }
    }
    return dataIdArray.join('');
}

export function getHyphenatedFromCamelCase(elId: string) {
    return elId.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function removeHTMLTagsAndIEStyleNewLines(elText: string) {
    // eslint-disable-next-line no-control-regex
    return elText.replace(/\u000D\u000A/g, '\u000A').replace(/<.*?>/g, '');
}

export function punctuateList(arr: unknown[] | nullish) {
    if (!arr || arr.length === 0) {
        return '';
    } else if (arr.length === 1) {
        return arr[0];
    }

    let phrase = '';
    const arrLength = arr.length;
    for (let i = 0; i < arrLength; i++) {
        phrase += arr[i];
        if (i === arrLength - 2) {
            phrase += ' and ';
        } else if (i < arrLength - 1) {
            phrase += ', ';
        }
    }
    return phrase;
}

export function getTooLongMessage(maxEntities: unknown, entityType: unknown) {
    return `<span>Too long! Please edit it down to under ${maxEntities} ${entityType}s.</span>`;
}
